// PostHog `nav_item_clicked` for the header and footer. The event name, the
// attribute names and the section/item vocabulary must match apps/web's copy —
// both apps serve this domain and one PostHog project. Change both sides.
//
// PostHog only: this app already fires Amplitude's `Nav Item Clicked` from its
// own onClick handlers, so mirroring it here too would double-count.

export const NAV_CLICK_EVENT = 'nav_item_clicked'

export type NavSurface = 'top' | 'footer'

export interface NavClickProperties extends Record<string, unknown> {
  nav_type: string | undefined
  nav_section: string | undefined
  nav_item: string | undefined
  /** null for a control that doesn't navigate, e.g. a dropdown trigger. */
  destination_url: string | null
}

/** Nesting two of these does nothing: `closest()` only finds the innermost. */
export function navAttrs(surface: NavSurface, section: string, item: string) {
  return {
    'data-ph-nav': surface,
    'data-ph-nav-section': section,
    'data-ph-nav-item': item,
  }
}

export function navTriggerItem(label: string) {
  return `${label} dropdown trigger`
}

function navClickProperties(el: HTMLElement): NavClickProperties {
  return {
    nav_type: el.dataset.phNav,
    nav_section: el.dataset.phNavSection,
    nav_item: el.dataset.phNavItem,
    destination_url: el instanceof HTMLAnchorElement ? el.href : null,
  }
}

let started = false

/** Registered once from `onClientEntry`; one document listener survives every
 *  SPA route change. */
export function initNavClickTracking() {
  if (started) return
  started = true

  document.addEventListener('click', (event) => {
    const target = event.target
    if (!(target instanceof Element)) return

    const el = target.closest<HTMLElement>('[data-ph-nav]')
    if (!el) return

    window.posthog?.capture(NAV_CLICK_EVENT, navClickProperties(el))
  })
}
